import { useEffect, useState } from 'react';

/**
 * ページ最上部からのスクロール量判定
 * @param {number} threshold 閾値
 * @returns {boolean} スクロール量が閾値を超えたかの判定
 */
export const useOnScroll = (threshold: number) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > threshold) {
        setScrolled(true);
      } else {
        setScrolled(false);
      }
    };
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [threshold]);

  return { scrolled };
};
